export default (httpClient) => ({
    getTemplates(personId) {
      return httpClient.hosts.v3.get(`rest/1/person/file/library/templates`,{
        person: personId,
        tinymce: 1
      });
    }
  });